import Jsona from "jsona";

export const dataFormatter = new Jsona();
